export default "__VITE_ASSET__BpFPi40T__"